import { UseCustomAxios } from "../../UseCustomAxios";
import { useSnackbar } from "notistack";

export function UseMotorDelivery() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();

  const getParts = (myPC, callback) => {
    MyAxios.get(`Admin_Logestic_DeliveryManage/parts`, {
      headers: {
        pageCondition: myPC,
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const GetGroupsPart = (DeliveryDate, DeliveryPart, callback, bool) => {
    MyAxios.get(`Admin_Logestic_MotorDelivery`, {
      headers: {
        IsPage: bool,
        Conditions: JSON.stringify({
          DeliveryDate: DeliveryDate,
          DeliveryPart: DeliveryPart,
        }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const GetOrdersRoute = (orderModel, callback) => {
    MyAxios.get(`Admin_Logestic_MotorDelivery/route`, {
      headers: {
        Conditions: JSON.stringify(orderModel),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const GetOrderByLogesticId = (model, callback) => {
    MyAxios.get(`Admin_Logestic_MotorRouting/order`, {
      headers: {
        Conditions: JSON.stringify(model),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      } else {
        callback();
      }
    });
  };

  const GetDriverHive = (orderModel, callback) => {
    MyAxios.get(`Admin_Logestic_MotorDelivery/hive`, {
      headers: {
        Conditions: JSON.stringify(orderModel),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      } else {
        callback(null);
      }
    });
  };

  const GetAllDrivers = (callback) => {
    MyAxios.get(`Admin_Logestic_MotorDelivery/alldrivers`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const GetActiveDrivers = (DeliveryDate, DeliveryPart, callback) => {
    MyAxios.get(`Admin_Logestic_MotorDelivery/drivers`, {
      headers: {
        Conditions: JSON.stringify({
          DeliveryDate: DeliveryDate,
          DeliveryPart: DeliveryPart,
        }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const GetDriversRoutes = (model, callback) => {
    MyAxios.get(`Admin_Logestic_MotorDelivery/driverrout`, {
      headers: {
        Conditions: JSON.stringify(model),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const AssignToDriver = (state, callback) => {
    const data = new FormData();
    if (state.zoneIndex == undefined) {
      delete state.zoneIndex;
    }
    if (state.orderID == undefined) {
      delete state.orderID;
    }
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_Logestic_MotorDelivery/assign`, data).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar("با موفقیت انجام شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback();
        }
      }
    );
  };

  const SendOrderSort = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_Logestic_MotorDelivery/sort`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar(" با موفقیت انجام شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const PickupToDriver = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_Logestic_MotorDelivery/pickup`, data).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar("تحویل با موفقیت انجام شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback();
        }
      }
    );
  };

  const setDeliverOrders = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_Logestic_MotorDelivery/deliver`, data).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar("ثبت نهایی با موفقیت انجام شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback();
        }
      }
    );
  };

  return {
    getParts,
    GetOrdersRoute,
    GetGroupsPart,
    GetActiveDrivers,
    GetDriversRoutes,
    AssignToDriver,
    SendOrderSort,
    PickupToDriver,
    GetAllDrivers,
    GetDriverHive,
    GetOrderByLogesticId,
    setDeliverOrders,
  };
}
